export const translations = {
  tr: {
    home: "Ana Sayfa",
    shop: "Tüm Ürünler",
    about: "Hakkımızda",
    contact: "İletişim",
    wishlist: "Favoriler",
    account: "Hesabım",
    login: "Giriş Yap",
    register: "Üye Ol",
    logout: "Çıkış Yap",
    search: "Ara...",
    searchProducts: "Ürün ara...",
    addToWishlist: "Favorilere Ekle",
    removeFromWishlist: "Favorilerden Çıkar",
    quickView: "Hızlı Bakış",
    orderWhatsapp: "WhatsApp ile Sipariş Ver",
    chatUsername: "Kullanıcı Adıyla Sohbet Et",
    description: "Ürün Açıklaması",
    reviews: "Değerlendirmeler",
    relatedProducts: "Benzer Ürünler",
    featured: "Öne Çıkan Modeller",
    womenSection: "Bayan Koleksiyonu",
    collectionSection: "Efsane Koleksiyonlar",
    accessorySection: "Aksesuarlar",
    viewAll: "Tümünü Gör",
    price: "Fiyat",
    filterBy: "Filtrele",
    allCategories: "Tüm Kategoriler",
    sortBy: "Sırala",
    newest: "En Yeni",
    priceLow: "Fiyat: Düşükten Yükseğe",
    priceHigh: "Fiyat: Yüksekten Düşüğe",
    noProducts: "Ürün bulunamadı.",
    email: "E-posta",
    password: "Şifre",
    name: "Ad Soyad",
    confirmPassword: "Şifre Tekrar",
    haveAccount: "Zaten hesabın var mı?",
    noAccount: "Henüz üye değil misin?",
    welcome: "Hoş geldiniz",
    myAccount: "Hesabım",
    signInTitle: "Hesabınıza Giriş Yapın",
    registerTitle: "Yeni Hesap Oluştur",
    adminPanel: "Yönetim Paneli",
    products: "Ürünler",
    categories: "Kategoriler",
    settings: "Ayarlar",
    analytics: "İstatistikler",
    emptyWishlist: "Favori listeniz boş.",
    startShopping: "Alışverişe Başla",
    freeShipping: "Ücretsiz Kargo",
    authentic: "%100 Orijinal Kalite",
    securePackaging: "Özel Kutu & Ambalaj",
    support: "7/24 Destek",
    tagline: "İSTANBUL'UN LÜKS SAAT EVİ",
    footerAbout: "Zarafet ve ustalığın buluştuğu adres.",
    quickLinks: "Hızlı Bağlantılar",
    followUs: "Bizi Takip Edin",
    rights: "Tüm hakları saklıdır.",
    reviewCount: "değerlendirme",
    inStock: "Stokta var",
    orderNote: "Ödeme yok — siparişinizi WhatsApp üzerinden hızlıca tamamlayın.",
    whatsappMsg: "Merhaba, bu ürünle ilgileniyorum:",
    waOrderIntro: "Merhaba! Aşağıdaki ürün için sipariş vermek istiyorum:",
    waProduct: "Ürün",
    waStock: "Stok Kodu",
    waPrice: "Fiyat",
    waListPrice: "Liste Fiyatı",
    waImage: "Görsel",
    waLink: "Ürün Linki",
    compare: "Karşılaştır",
    addToCompare: "Karşılaştırmaya Ekle",
    removeFromCompare: "Karşılaştırmadan Çıkar",
    clearCompare: "Listeyi Temizle",
    emptyCompare: "Karşılaştırma listeniz boş.",
    comparePage: "Ürün Karşılaştırma",
    maxCompare: "En fazla 4 ürün karşılaştırılabilir.",
    share: "Paylaş",
    copyLink: "Bağlantıyı Kopyala",
    linkCopied: "Bağlantı kopyalandı!",
    addedCompare: "Karşılaştırmaya eklendi",
    discountOff: "İNDİRİM",
    specs: "Teknik Özellikler",
    specBrand: "Marka",
    specMovement: "Mekanizma",
    specCase: "Kasa Malzemesi",
    specDiameter: "Kasa Çapı",
    specGlass: "Cam",
    specWater: "Su Geçirmezlik",
    specWarranty: "Garanti",
    specRating: "Puan",
    specPrice: "Fiyat",
    stockCode: "Stok Kodu",
    categoriesLabel: "Kategoriler",
    tagsLabel: "Etiketler",
    videoLabel: "Video",
  },
  en: {
    home: "Home",
    shop: "All Products",
    about: "About",
    contact: "Contact",
    wishlist: "Wishlist",
    account: "Account",
    login: "Sign In",
    register: "Register",
    logout: "Sign Out",
    search: "Search...",
    searchProducts: "Search products...",
    addToWishlist: "Add to Wishlist",
    removeFromWishlist: "Remove from Wishlist",
    quickView: "Quick View",
    orderWhatsapp: "Order via WhatsApp",
    chatUsername: "Chat with Username",
    description: "Description",
    reviews: "Reviews",
    relatedProducts: "You May Also Like",
    featured: "Featured Timepieces",
    womenSection: "Women's Collection",
    collectionSection: "Iconic Collections",
    accessorySection: "Accessories",
    viewAll: "View All",
    price: "Price",
    filterBy: "Filter",
    allCategories: "All Categories",
    sortBy: "Sort by",
    newest: "Newest",
    priceLow: "Price: Low to High",
    priceHigh: "Price: High to Low",
    noProducts: "No products found.",
    email: "Email",
    password: "Password",
    name: "Full Name",
    confirmPassword: "Confirm Password",
    haveAccount: "Already have an account?",
    noAccount: "Don't have an account?",
    welcome: "Welcome",
    myAccount: "My Account",
    signInTitle: "Sign In to Your Account",
    registerTitle: "Create a New Account",
    adminPanel: "Admin Panel",
    products: "Products",
    categories: "Categories",
    settings: "Settings",
    analytics: "Analytics",
    emptyWishlist: "Your wishlist is empty.",
    startShopping: "Start Shopping",
    freeShipping: "Free Shipping",
    authentic: "100% Authentic Quality",
    securePackaging: "Premium Boxing & Packaging",
    support: "24/7 Support",
    tagline: "ISTANBUL'S HOUSE OF FINE WATCHES",
    footerAbout: "Where elegance meets craftsmanship.",
    quickLinks: "Quick Links",
    followUs: "Follow Us",
    rights: "All rights reserved.",
    reviewCount: "reviews",
    inStock: "In stock",
    orderNote: "No payment — complete your order quickly via WhatsApp.",
    whatsappMsg: "Hello, I'm interested in this product:",
    waOrderIntro: "Hello! I'd like to place an order for the product below:",
    waProduct: "Product",
    waStock: "Stock Code",
    waPrice: "Price",
    waListPrice: "List Price",
    waImage: "Image",
    waLink: "Product Link",
    compare: "Compare",
    addToCompare: "Add to Compare",
    removeFromCompare: "Remove from Compare",
    clearCompare: "Clear List",
    emptyCompare: "Your compare list is empty.",
    comparePage: "Compare Products",
    maxCompare: "You can compare up to 4 products.",
    share: "Share",
    copyLink: "Copy Link",
    linkCopied: "Link copied!",
    addedCompare: "Added to compare",
    discountOff: "OFF",
    specs: "Specifications",
    specBrand: "Brand",
    specMovement: "Movement",
    specCase: "Case Material",
    specDiameter: "Case Diameter",
    specGlass: "Glass",
    specWater: "Water Resistance",
    specWarranty: "Warranty",
    specRating: "Rating",
    specPrice: "Price",
    stockCode: "Stock Code",
    categoriesLabel: "Categories",
    tagsLabel: "Tags",
    videoLabel: "Video",
  },
};
